import { render, staticRenderFns } from "./AddCommunication.vue?vue&type=template&id=f820fa70&"
import script from "./AddCommunication.vue?vue&type=script&lang=js&"
export * from "./AddCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports